/* import api from '../_api'; */
import moment from 'moment';
import { APIindustryOverviewRequest } from '../../../assets/requests/request';
import { extractMaxValuesIndustryOverview } from '../../../assets/js/functions';
import { store } from '../../../store/store';

const updateSummaryCharts = ({ commit, rootState }) => {
  const { comparisonMode } = rootState;
  const { comparisonYears } = rootState;
  const { clientOrRareMode } = rootState;
  const { toDate } = rootState.requestParams;
  const { fromDate } = rootState.requestParams;
  const displayDateFormat = 'DD/MM/YYYY';
  const processDateFormat = 'YYYY-MM-DD';
  const { industryAverage } = rootState.requestParams;
  const requestingClient = (clientOrRareMode === 'rare' ? 'rare' : rootState.requestParams.currentClient);
  const clientName = rootState.requestParams.currentClient;
  const industryLegend = [];

  const industryFilters = [];
  const baseFilter = {
    name: 'base',
    client: clientName,
    sector: industryAverage,
    fromDate,
    toDate,
  };

  let legendFromDate = moment(fromDate).format(displayDateFormat);
  let legendToDate = moment(toDate).format(displayDateFormat);

  industryLegend.push(`${legendFromDate} - ${legendToDate}`);
  industryFilters.push(baseFilter);

  if (comparisonMode === 'date') {
    for (let i = 1; i <= comparisonYears; i += 1) {
      const yearOnYearFilter = {
        name: `prevYear${i}`,
        client: clientName,
        sector: industryAverage,
        fromDate: moment(fromDate).subtract(i, 'years').format(processDateFormat),
        toDate: moment(toDate).subtract(i, 'years').format(processDateFormat),
      };
      legendFromDate = moment(fromDate).subtract(i, 'years').format(displayDateFormat);
      legendToDate = moment(toDate).subtract(i, 'years').format(displayDateFormat);
      industryFilters.push(yearOnYearFilter);
      industryLegend.push(`${legendFromDate} - ${legendToDate}`);
    }
  }

  const industryRequest = {
    searchIn: 'api-uk3',
    overviews: industryFilters,
    requesting_client: requestingClient,
  };

  commit('updateIndustryLegend', industryLegend);

  function processResponse(response) {
    const chartData = {};

    response.overview_data.forEach((overviewData) => {
      const { name } = overviewData;
      const adjustedOverviewData = overviewData.data;

      if (rootState.clientOrRareMode === 'client') {
        const filteredClients = Object.keys(overviewData.data).filter((client) => /Organisation/.test(client));

        if (filteredClients.length <= 5) {
          filteredClients.forEach((client) => {
            delete adjustedOverviewData[client];
          });
        }
      }

      chartData[name] = adjustedOverviewData;
    });

    commit('updateIndustryChartData', chartData);
    commit('updateIndustryMaxValues', extractMaxValuesIndustryOverview(response.overview_data));
  }

  return new Promise((resolve, reject) => {
    const hash = rootState.requestParams.currentParamsHash;
    if (hash in rootState.responseCache.industry) {
      processResponse(rootState.responseCache.industry[hash]);
      resolve(true);
    } else {
      const requestParams = {
        headers: { 'x-dashboard-token': store.getters['$_login/accessToken'] },
        auth: {
          username: store.getters['$_login/userName'],
          password: '',
        },
      };
      APIindustryOverviewRequest.post('', industryRequest, requestParams).then((response) => {
        if (response.status !== 200) {
          throw new Error('Request not successful');
        }
        processResponse(response.data);
        commit('addAPIresponseToCache', { response: response.data, module: 'industry' }, { root: true });
        resolve(response);
      }, (error) => {
        reject(error);
      });
    }
  });
};

export default {
  updateSummaryCharts,
};
